import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
  Chip,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewAgentConfigurationModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewAgentConfigurationModal: React.FC<ViewAgentConfigurationModalProps> = ({ open, onClose }) => {
  const { selectedAgent, loading } = useAppSelector((state) => state.agentConfigurations);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Detalle de Configuración de Agente</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedAgent ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Clave del Agente
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedAgent.agentKey}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Proveedor
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedAgent.provider}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Modelo
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedAgent.modelName}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Temperatura
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedAgent.temperature}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Max Tokens
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedAgent.maxTokens}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Max Output Tokens
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedAgent.maxOutputTokens}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Max Reintentos
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedAgent.maxRetries}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Top P
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedAgent.topP}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Descripción
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedAgent.description}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Estado
              </Typography>
              <Box sx={{ mt: 0.5, mb: 2 }}>
                <Chip
                  label={selectedAgent.isEnabled ? 'Habilitado' : 'Deshabilitado'}
                  color={selectedAgent.isEnabled ? 'success' : 'default'}
                  size="small"
                />
              </Box>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Creación
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedAgent.createdAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Creado Por
              </Typography>
              <Typography variant="body1">
                {selectedAgent.createdBy}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography>No hay agente seleccionado</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewAgentConfigurationModal;
